import { FlexBox, Page, Spinner } from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppPathParams } from 'utils/url/useAppPathParams';

import { CustomForm } from '../../customForms.types';
import { useCustomForms } from '../../hooks/useCustomForms/useCustomForms';

import { EditFormSection } from './components/editFormSection/editFormSection';
import { FormEditPageTitle } from './components/formEditPageTitle';
import { WebformEndpointsSection } from './components/webformEndpointsSection/webformEndpointsSection';

export function FormsEditPage(): JSX.Element | null {
  const [form, setForm] = useState<CustomForm | undefined>(undefined);
  const { formId } = useAppPathParams('/settings/custom-forms/edit/:formId');
  const { getSingleForm, isLoading } = useCustomForms();

  const { hasCustomFormsV2Feature } = useFeatureFlag([
    'has-custom-forms-v2-feature',
  ]);

  useEffect(() => {
    const fetchForm = async () => {
      const result = await getSingleForm(formId);
      if (result.ok) {
        setForm(result.value);
      }
    };

    fetchForm();
  }, [formId, getSingleForm]);

  if (isLoading) {
    <FlexBox flex="1" justifyContent="center" alignItems="center">
      <Spinner />
    </FlexBox>;
  }

  if (!form) {
    return null;
  }

  return (
    <Page>
      <Page.Head title={<FormEditPageTitle formName={form.title} />} />

      <Page.Body>
        <EditFormSection form={form} />
        {hasCustomFormsV2Feature && (
          <WebformEndpointsSection formId={form.id} />
        )}
      </Page.Body>
    </Page>
  );
}
